const art0 = {
  "link": "https://farm5.static.flickr.com/4006/4277453916_1dc30fc85f_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art1 = {
  "link": "https://farm3.static.flickr.com/2739/4274981274_0c5de50956_o.jpg",
  "title": 'Polkadot',
  "media": 'At Mazer Theater at Education Alliance, New York, NY USA',
  "statement": 'Interdisciplinary performance art.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art2 = {
  "link": "https://farm3.static.flickr.com/2420/3701084099_7cec930f9f_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art3 = {
  "link": "https://farm3.static.flickr.com/2592/3717142869_f753a2a376_o.jpg",
  "title": 'linebreak',
  "media": 'At 320 Studios, New York, NY USA',
  "statement": 'Interdisciplinary performance comission for Financial Corps fundraising event. Inspirations: Intersection of various lives. Constrution and deconstruction.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art4 = {
  "link": "https://farm3.static.flickr.com/2570/3720653109_3c2cf47bce_o.jpg",
  "title": 'fella',
  "media": 'at the virginia center for the creative arts, amherst, va, usa',
  "statement": 'outdoor interdisciplinary performance.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art5 = {
  "link": "https://farm4.static.flickr.com/3441/3714003171_d82bf615df_o.jpg",
  "title": 'glimmer',
  "media": 'at i-park, east haddam, ct',
  "statement": 'outdoor installation and performance in the forest.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art6 = {
  "link": "https://farm3.static.flickr.com/2662/3726965093_9416ca7b81_o.jpg",
  "title": 'mirror',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'I stand in front of a mirror. Eyes stand out first. I notice the shape of the mouth, the opening width of it. Nose shows the tilt of the face most significantly. Hair obstructs the outline, so I lift it to see contour. I tilt my head further, to check if everything is at the right angle. I move to the side, or squat down a bit, so that I can see what I draw on the mirror. The surface is very shiny and my pens are semitransparent. From an angle, I try to confirm if what I have drawn matches what I think I see. Then I bring myself back to the original position, the right position. I start to see the colors. Cold or warm. Mat or Shiny. place the dark lines. finalize the image. And Shatter.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art7 = {
  "link": "https://farm4.static.flickr.com/3002/3720893609_b3e5f2ebca_o.jpg",
  "title": 'tsumiki',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'repeating continuously during the exhibition, i build a meticulously perfect geometric structure that surrounds me and appears to trap me inside. once the structure is complete, i come out of it at once using only the force of my body. once outside of the structure, i rush to clean it up and start building it again from the dismantled structure. each construction takes about 15-20 minutes.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art8 = {
  "link": "https://farm3.static.flickr.com/2569/3725708642_92884656f1_o.jpg",
  "title": 'water',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'i draw surrounding people and objects as well as trees to represent nature, only using water and a brush. as it dries, the image disappears.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art9 = {
  "link": "https://farm3.static.flickr.com/2569/3724739472_a5c8ab40e6_o.jpg",
  "title": 'seesaw',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'live performance in the window space on busy street in nyc. i walked extremely slow motion as in buddhist meditation (3-4 min. to cross 8 feet seesaw) back and forth on top of seesaw for the 3 day group performance event',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art10 = {
  "link": "https://farm5.static.flickr.com/4053/4276536493_f89f2e5e06_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art11 = {
  "link": "https://farm5.static.flickr.com/4063/4274235829_4cec39d71f_o.jpg",
  "title": 'Polkadot',
  "media": 'At Mazer Theater at Education Alliance, New York, NY USA',
  "statement": 'Interdisciplinary performance art.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art12 = {
  "link": "https://farm4.static.flickr.com/3430/3701892742_c8c80240c1_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art13 = {
  "link": "https://farm3.static.flickr.com/2492/3717142029_86ae226728_o.jpg",
  "title": 'linebreak',
  "media": 'At 320 Studios, New York, NY USA',
  "statement": 'Interdisciplinary performance comission for Financial Corps fundraising event. Inspirations: Intersection of various lives. Constrution and deconstruction.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art14 = {
  "link": "https://farm4.static.flickr.com/3518/3723834565_8b46f8f8b6_o.jpg",
  "title": 'fella',
  "media": 'at the virginia center for the creative arts, amherst, va, usa',
  "statement": 'outdoor interdisciplinary performance.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art15 = {
  "link": "https://farm3.static.flickr.com/2554/3723979603_4f61766199_o.jpg",
  "title": 'glimmer',
  "media": 'at i-park, east haddam, ct',
  "statement": 'outdoor installation and performance in the forest.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art16 = {
  "link": "https://farm3.static.flickr.com/2645/3720894233_727dd3474f_o.jpg",
  "title": 'tsumiki',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'repeating continuously during the exhibition, i build a meticulously perfect geometric structure that surrounds me and appears to trap me inside. once the structure is complete, i come out of it at once using only the force of my body. once outside of the structure, i rush to clean it up and start building it again from the dismantled structure. each construction takes about 15-20 minutes.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art17 = {
  "link": "https://farm4.static.flickr.com/3462/3721120565_88359d947a_o.jpg",
  "title": 'seesaw',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'live performance in the window space on busy street in nyc. i walked extremely slow motion as in buddhist meditation (3-4 min. to cross 8 feet seesaw) back and forth on top of seesaw for the 3 day group performance event',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art20 = {
  "link": "https://farm3.static.flickr.com/2801/4276536239_d9af88850d_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art21 = {
  "link": "https://farm5.static.flickr.com/4006/4274235477_2d2f024563_o.jpg",
  "title": 'Polkadot',
  "media": 'At Mazer Theater at Education Alliance, New York, NY USA',
  "statement": 'Interdisciplinary performance art.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art22 = {
  "link": "https://farm3.static.flickr.com/2636/3724838050_01b6514f2c_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art23 = {
  "link": "https://farm4.static.flickr.com/3456/3717957142_319d3a2cbf_o.jpg",
  "title": 'linebreak',
  "media": 'At 320 Studios, New York, NY USA',
  "statement": 'Interdisciplinary performance comission for Financial Corps fundraising event. Inspirations: Intersection of various lives. Constrution and deconstruction.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art24 = {
  "link": "https://farm3.static.flickr.com/2493/3720653581_4390f20fdf_o.jpg",
  "title": 'fella',
  "media": 'at the virginia center for the creative arts, amherst, va, usa',
  "statement": 'outdoor interdisciplinary performance.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art25 = {
  "link": "https://farm3.static.flickr.com/2610/3714779488_d39cefba40_o.jpg",
  "title": 'glimmer',
  "media": 'at i-park, east haddam, ct',
  "statement": 'outdoor installation and performance in the forest.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art26 = {
  "link": "https://farm4.static.flickr.com/3433/3720893965_197612253f_o.jpg",
  "title": 'tsumiki',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'repeating continuously during the exhibition, i build a meticulously perfect geometric structure that surrounds me and appears to trap me inside. once the structure is complete, i come out of it at once using only the force of my body. once outside of the structure, i rush to clean it up and start building it again from the dismantled structure. each construction takes about 15-20 minutes.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art27 = {
  "link": "https://farm3.static.flickr.com/2512/3724739538_b4b96e75d5_o.jpg",
  "title": 'seesaw',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'live performance in the window space on busy street in nyc. i walked extremely slow motion as in buddhist meditation (3-4 min. to cross 8 feet seesaw) back and forth on top of seesaw for the 3 day group performance event',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art30 = {
  "link": "https://farm5.static.flickr.com/4055/4276535579_886a0e8205_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art31 = {
  "link": "https://farm5.static.flickr.com/4046/4274235549_815e5131b5_o.jpg",
  "title": 'Polkadot',
  "media": 'At Mazer Theater at Education Alliance, New York, NY USA',
  "statement": 'Interdisciplinary performance art.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art32 = {
  "link": "https://farm3.static.flickr.com/2521/3701892612_cecdc22ff2_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art33 = {
  "link": "https://farm4.static.flickr.com/3447/3717957576_f338128ddd_o.jpg",
  "title": 'linebreak',
  "media": 'At 320 Studios, New York, NY USA',
  "statement": 'Interdisciplinary performance comission for Financial Corps fundraising event. Inspirations: Intersection of various lives. Constrution and deconstruction.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art34 = {
  "link": "https://farm3.static.flickr.com/2470/3720653819_4a4a83ae70_o.jpg",
  "title": 'fella',
  "media": 'at the virginia center for the creative arts, amherst, va, usa',
  "statement": 'outdoor interdisciplinary performance.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art35 = {
  "link": "https://farm4.static.flickr.com/3454/3723979467_09c170d54f_o.jpg",
  "title": 'glimmer',
  "media": 'at i-park, east haddam, ct',
  "statement": 'outdoor installation and performance in the forest.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art36 = {
  "link": "https://farm3.static.flickr.com/2483/3723880875_361917bd0a_o.jpg",
  "title": 'tsumiki',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'repeating continuously during the exhibition, i build a meticulously perfect geometric structure that surrounds me and appears to trap me inside. once the structure is complete, i come out of it at once using only the force of my body. once outside of the structure, i rush to clean it up and start building it again from the dismantled structure. each construction takes about 15-20 minutes.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art37 = {
  "link": "https://farm3.static.flickr.com/2434/3722216577_213f96e9f1_o.jpg",
  "title": 'seesaw',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'live performance in the window space on busy street in nyc. i walked extremely slow motion as in buddhist meditation (3-4 min. to cross 8 feet seesaw) back and forth on top of seesaw for the 3 day group performance event',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art40 = {
  "link": "https://farm5.static.flickr.com/4069/4277279474_f4b4ec388e_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art41 = {
  "link": "https://farm5.static.flickr.com/4027/4274235769_02e623b57c_o.jpg",
  "title": 'Polkadot',
  "media": 'At Mazer Theater at Education Alliance, New York, NY USA',
  "statement": 'Interdisciplinary performance art.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art42 = {
  "link": "https://farm3.static.flickr.com/2558/3724837968_eea3f7741f_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art43 = {
  "link": "https://farm3.static.flickr.com/2550/3717958220_c4392dd295_o.jpg",
  "title": 'linebreak',
  "media": 'At 320 Studios, New York, NY USA',
  "statement": 'Interdisciplinary performance comission for Financial Corps fundraising event. Inspirations: Intersection of various lives. Constrution and deconstruction.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art44 = {
  "link": "https://farm3.static.flickr.com/2468/3720653867_539c3c5d28_o.jpg",
  "title": 'fella',
  "media": 'at the virginia center for the creative arts, amherst, va, usa',
  "statement": 'outdoor interdisciplinary performance.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art45 = {
  "link": "https://farm3.static.flickr.com/2563/3714813466_9be109e7b5_o.jpg",
  "title": 'glimmer',
  "media": 'at i-park, east haddam, ct',
  "statement": 'outdoor installation and performance in the forest.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art46 = {
  "link": "https://farm4.static.flickr.com/3437/3720894045_65b62f1547_o.jpg",
  "title": 'tsumiki',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'repeating continuously during the exhibition, i build a meticulously perfect geometric structure that surrounds me and appears to trap me inside. once the structure is complete, i come out of it at once using only the force of my body. once outside of the structure, i rush to clean it up and start building it again from the dismantled structure. each construction takes about 15-20 minutes.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art47 = {
  "link": "https://farm3.static.flickr.com/2621/3723930707_eef04ccd42_o.jpg",
  "title": 'seesaw',
  "media": 'at exit art, nyc. live audience performance project',
  "statement": 'live performance in the window space on busy street in nyc. i walked extremely slow motion as in buddhist meditation (3-4 min. to cross 8 feet seesaw) back and forth on top of seesaw for the 3 day group performance event',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art50 = {
  "link": "https://farm3.static.flickr.com/2534/4276535317_6095db4d97_o.jpg",
  "title": 'Blindfaith',
  "media": 'At Exit Art (as part of the Performance in Crisis series), New York, NY',
  "statement": 'Multimedia live performance. A live goldfish in a clear glass bowl is placed on a pedestal at each end of the space. Two performers mirror the same action repeatedly: one takes a cup of water from bowl A and pours it into bowl B, and the other does the opposite. In the center, the third performer walks in a large circle repeatedly. She is blindfolded and carries a live fish in a bowl. She dips her feet in this bowl making her footprints on the concrete floor. A 5 minute audio-visual file is projected on a wall and repeated throughout.',
  "imageShape": "landscape",
  "includeingallery": true,
}
const art52 = {
  "link": "https://farm3.static.flickr.com/2625/3701084519_782bb8a493_o.jpg",
  "title": 'kasa-casa',
  "media": 'Funded by NYC Department of Cultural Affairs, administered by Lower Manhattan Cultural Council',
  "statement": 'Interdisciplinary performance art presented at IS143 in Washington Heights, New York.',
  "imageShape": "landscape",
  "includeingallery": true,
}

const art = [
    art0,
    art1,
    art2,
    art3,
    art4,
    art5,
    art6,
    art7,
    art8,
    art9,
    art10,
    art11,
    art12,
    art13,
    art14,
    art15,
    art17,
    art20,
    art21,
    art22,
    art23,
    art24,
    art25,
    art27,
    art30,
    art31,
    art32,
    art33,
    art34,
    art35,
    art37,
    art40,
    art41,
    art42,
    art43,
    art44,
    art45,
    art47,
    art50,
    art52
]

export default art
